<script>
    /**
     * proofResult
     */
    import ModalHeader from './ModalHeader.vue';
    import ModalFooter from './ModalFooter.vue';
    import NormalButton from '../widgets/NormalButton.vue';
    import MultipleSelect from '../widgets/MultipleSelect.vue';
    import Loading from '../widgets/Loading.vue';
    import WidgetPopupTips from '../widgets/proof/widget-popup-tips.vue';

    const CACHE_DATA = {
        textList: '',
        proofResult: null
    };
    // import moment from 'moment';

    export default {
        alias: 'proofResult',
        defaultOptions () {
            return {
                title: '查看文档校对结果'
            };
        },
        async modalCreated (options) {
            for (let key in options) {
                this[key] = options[key];
            }
            this.init();
        },
        data () {
            return {
                version: 0,
                title: '',
                task: '',
                isDrag: true,
                loading: false,
                exportLoading: false,
                showRight: true,
                params: {
                    labelTerm: '',
                    content: '',
                    text: '',
                    contentEditable: true
                },
                proofRight: {
                    contentHtml: ''
                },
                proofLeft: {
                    contentHtml: ''
                }
            };
        },
        computed: {
            options () {
                if (!this.version) {
                    return [
                        {
                            value: 'POLITICAL_MUST_RIGHT',
                            text: '导向敏感词查错'
                        },
                        {
                            value: 'POLICY_FILE',
                            text: '政策文件查错'
                        },
                        {
                            value: 'CENTRAL_WORK',
                            text: '中心工作提法查错'
                        },
                        {
                            value: 'DEPT_NAME',
                            text: '机构名称查错'
                        },
                        {
                            value: 'TITLE_AND_NAME',
                            text: '领导姓名头衔查错'
                        },
                        {
                            value: 'IMPORTANT_NAME',
                            text: '重点姓名查错'
                        },
                        {
                            value: 'L_SENSITIVE',
                            text: '敏感词提醒'
                        },
                        {
                            value: 'PRIVACY',
                            text: '隐私信息查找'
                        }
                    ]
                }
                return [
                    {value: 'POLITICAL_PHRASE_CORE', text: '核⼼导向'},
                    {value: 'POLITICAL_PHRASE', text: '固定提法'},
                    {value: 'IMPORTANT_NAME', text: '重点姓名'},
                    {value: 'TITLE_AND_NAME', text: '领导姓名头衔'},
                    {value: 'DEPT_NAME', text: '机构名称'},
                    {value: 'POLICY_NAME', text: '政策名称'},
                    {value: 'AXED_OFFICIAL', text: '落⻢官员'},
                    {value: 'POLITICAL_FORBIDDEN', text: '政治违禁'},
                    {value: 'PORN', text: '⾊情'},
                    {value: 'TERROR', text: '暴恐'},
                    {value: 'ABUSE', text: '谩骂'},
                    {value: 'ILLEGAL', text: '赌博⿊产'},
                    {value: 'AD', text: '⼴告⾏为'},
                    {value: 'HEIMA', text: '字词校对'},
                    {value: 'IFUNCUN', text: '⽅⼨校对'},
                    {value: 'L_PRIVACY', text: '隐私信息'},
                    {value: 'L_TYPO', text: '错别字查找'},
                    {value: 'L_IGNORE', text: '模糊查找忽略',disabled:true},
                ]
            },
        },
        name: 'modal-proof-result',
        methods: {
            async init () {
                this.loading = true;
                // await this.initIndexedDb();
                this.handleProofResult();
            },
            async initIndexedDb () {
                try {
                    const config = this.$config.indexedDbConfig;
                    const {type, instance} = await this.$indexedDb(config);
                    if (type === 'upgrade') {
                        // 创建一个数据库存储对象
                        var objectStore = instance.createObjectStore(config.name, {
                            keyPath: 'task',
                        });
                        // 定义存储对象的数据项
                        objectStore.createIndex('task', 'task', {
                            unique: true
                        });
                        objectStore.createIndex('text', 'text');
                        objectStore.createIndex('result', 'result');
                        objectStore.createIndex('filename', 'filename');
                    }
                } catch (e) {
                    console.log(e);
                }
            },
            handleProofResult () {
                let {result, text, version = 1} = this.resultData;
                this.version = version;
                // this.title = `${ this.clientConfig.proof.title } - ${ filename }的校对结果`;

                CACHE_DATA.textList = text.split('\n');
                CACHE_DATA.proofResult = JSON.parse(result);
                CACHE_DATA.proofResult.flat().forEach(val => {
                    if (!version) {
                        val.label = val.labels;
                    }
                });
                // readyToDocx(task, CACHE_DATA.textList, CACHE_DATA.textList , filename);
                CACHE_DATA.proofResult.forEach(v => {
                    v.forEach(d => {
                        d.linkId = this.$util.randomId();
                    });
                });

                let proofResult = this.$util.changeProofDataClient(CACHE_DATA.textList, this.$util.deepCopy(CACHE_DATA.proofResult));
                const {content, proofHtml, wordMap} = proofResult;
                let html = '';
                content.forEach((txt, i) => {
                    if (i % 5000 === 0) {
                        html += `<div style="display: ${ i ? 'none' : 'block' }" class="parent-mark">`;
                    }
                    html += `<p>${ txt }</p>`;
                    if (i % 5000 === 4999 || (i === content.length - 1)) {
                        html += '</div>';
                    }
                });
                CACHE_DATA.wordMap = wordMap;

                this.proofRight.contentHtml = proofHtml;
                this.proofLeft.contentHtml = html;

                const $allP = Array.from(this.$el.querySelectorAll('.parent-mark'));

                $allP.forEach(el => {
                    el.style.display = 'block';
                });
                this.loading = false;
            },
            async onConfirm () {
                if (this.exportLoading) {
                    return;
                }
                this.exportLoading = true;
                const html = await this.$util.readyToDocx(CACHE_DATA.textList, CACHE_DATA.proofResult);
                this.$util.exportHTML(html, `${ this.resultData.filename }上传的校对结果.doc`);
                this.exportLoading = false;
            },
            onDestroy (flag) {
                this.cancelCallback && this.cancelCallback();
                flag && this.close();
            },
            handleLabelTermChange ($e) {
                const {proofResult, textList} = CACHE_DATA;
                if (proofResult && textList) {
                    const result = this.$util.changeProofDataClient(textList, proofResult, true, $e.split(','));
                    this.proofRight.contentHtml = result.proofHtml;
                }
            },
            // 通过dataset寻找元素
            findElByDataset (path, value, cb) {
                return path.find(v => v.dataset
                    && v.dataset[value]
                    && (cb ? cb(v) : true));
            },
            handleProofRightClick ($e) {
                // 获取点击元素完整路径
                let path = this.$util.getDomPath($e);

                // 如果是data-target
                const item = this.findElByDataset(path, 'target', (item) => {
                    return !item.dataset.target.includes('$');
                });

                // 如果是data-value: showAll
                const showItem = this.findElByDataset(path, 'value', (target) => {
                    return target.dataset.value === 'showAll';
                });

                if (showItem) {
                    this.handleShowAll(showItem);
                } else if (item) {
                    this.handleScrollView(item.dataset.target);
                }
            },
            // 某项全部展示还是部分展示
            handleShowAll (target) {
                target.classList.toggle('active');
                target.parentElement.nextElementSibling.classList.toggle('text-hide');
            },
            // 定位到选择的词
            handleScrollView (selector) {
                const $el = document.querySelector(selector);
                // 滚动页面
                if ($el) {
                    $el.scrollIntoView(true);

                    // 移除选中
                    const $active = document.querySelector('.common-proof-word-item.active');
                    $active && $active.classList.remove('active');

                    $el.classList.add('active');
                }
            },
            handleLeftContentClick ($e) {
                const {target} = $e;
                if (target.classList.contains('common-proof-word-item') && Number(target.dataset.complete) !== 1) {
                    $e.stopPropagation();
                    const word = CACHE_DATA.wordMap[target.id];
                    this.$bus.$emit('show:tips', 'left-click', target, {
                        word: word.source,
                        color: target.style.backgroundColor,
                        text: word.term ? `修改意见：${ word.term }` : word.remark
                    });
                }
            },
            handleScroll () {
                this.$bus.$emit('hide:tips', 'left-click');
            },
            viewResult() {
                this.showRight = !this.showRight;
            }
        },
        components: {
            Loading,
            ModalHeader,
            NormalButton,
            ModalFooter,
            MultipleSelect,
            WidgetPopupTips
        }
    };
</script>

<template>
    <div class="modal"
         :class="{width1000: showRight}">
        <!-- <widget-popup-tips name="left-click"/> -->
        <modal-header :text="title" :is-drag="isDrag"
                      @close="onDestroy(false)"></modal-header>
        <div class="modal-content">
            <loading :visible="loading"></loading>
            <div class="modal-content-left"
                 @scroll="handleScroll"
                 @click="handleLeftContentClick"
                 v-html="proofLeft.contentHtml">

            </div>
            <div class="modal-content-right"
                 v-if="showRight">
                <div class="header">
                    <h2>校对结果</h2>
                    <div>
                        <multiple-select :options="options"
                                         @change="handleLabelTermChange"
                                         placeholder="请选择类型"
                                         sampleText="类型"
                                         v-model="params.labelTerm"/>
                    </div>
                </div>
                <div class="proof-right-context"
                     @click="handleProofRightClick"
                     id="proof-right-context"
                     v-html="proofRight.contentHtml">
                </div>
            </div>
        </div>
        <modal-footer>
            <normal-button @click="onConfirm();"
                           class="modal-footer-btn__center"
                           float="left"
                           text="导出"
                           :loading="exportLoading"
                           theme="blue"
            ></normal-button>
            <normal-button @click="viewResult();"
                           class="modal-footer-btn__center"
                           float="right"
                           text="校对结果速览"
                           :loading="exportLoading"
                           theme="blue"
            ></normal-button>
        </modal-footer>
    </div>
</template>

<style lang="less" scoped>
@import "../../assets/less/widgets-var.less";
    .iconfont-2 {
        font-family: cmsicon;
    }
    .modal {
        .modal-style;
        &.width1000 {
            width: 1000px !important;

            .modal-content-left {
                width: 600px !important;
            }
        }

        .modal-header {
            /deep/ .text {
                max-width: calc(100% - 100px);
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap
            }
        }

        .modal-content {
            height: 540px;
            position: relative;
            padding: 0;

            &-left {
                padding: 30px;
                box-sizing: border-box;
                width: 600px;
                height: 540px;
                border-right: 1px solid @otherBorderClr;
                overflow: auto;
                /deep/.common-proof-word-item.active {
                    font-size: 22px!important;
                    font-weight: bold!important;
                }
            }

            &-right {
                position: absolute;
                right: 0;
                top: 0;
                bottom: 0;
                width: 400px;

                .header {
                    box-sizing: border-box;
                    padding: 10px 30px;
                    z-index: 10;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    .drop-frame {
                        width: 200px;
                    }

                }

                .proof-right-context {
                    box-sizing: border-box;
                    padding: 0 20px;
                    width: 100%;
                    overflow-x: hidden;
                    overflow-y: auto;
                    height: 455px;

                    /deep/ .common-proof-item {
                        border-bottom: @border-weak;
                        cursor: pointer!important;

                        &:hover {
                            background-color: #F5F8FC!important;
                        }

                        .common-proof-item-op {
                            display: none !important;
                        }

                        .text-hide {
                            text-overflow: ellipsis;
                            overflow: hidden;
                            white-space: nowrap;
                        }

                        &__show-all{
                            .iconfont-2 {
                                display: inline-block;
                                transition: all ease-in 0.2s;
                            }
                            &.active .iconfont-2 {
                                transform: rotate(180deg);
                            }
                        }
                    }
                }
            }

        }
    }
</style>
